<template>
  <k-basic-modal-layout>
    <template v-slot:header>
      <h1 class="hasab-title">Esemény</h1>
    </template>
    <template v-slot:body>
      <b-form @submit.prevent="OnSubmit" :id="formId">
        <div class="container px-2">
          <div class="row no-gutters">
            <div class="col-6 pr-2">
              <b-form-group label="Esemény neve">
                <k-basic-text-input
                  v-model="$v.form.Nev.$model"
                  :validator="$v.form.Nev"
                  autofocus
                ></k-basic-text-input>
              </b-form-group>
            </div>
            <div class="col-6 pl-2">
              <b-form-group label="Esemény típusa">
                <k-basic-multi-select
                  v-model="$v.form.EsemenyTipusa.$model"
                  :validator="$v.form.EsemenyTipusa"
                  :options="esemenyTipusok"
                  labelBy="Text"
                ></k-basic-multi-select>
              </b-form-group>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-6 pr-2">
              <b-form-group label="Esemény kezdete">
                <k-html-date-picker
                  v-model="$v.form.Kezdete.$model"
                  :validator="$v.form.Kezdete"
                  mode="dateTime"
                ></k-html-date-picker>
              </b-form-group>
            </div>
            <div class="col-6 pl-2">
              <b-form-group label="Esemény vége">
                <k-html-date-picker
                  v-model="$v.form.Vege.$model"
                  :validator="$v.form.Vege"
                  mode="dateTime"
                ></k-html-date-picker>
              </b-form-group>
            </div>
          </div>
          <div class="row no-gutters">
            <div class="col-6 pr-2">
              <b-form-group label="Esemény jellege">
                <k-basic-multi-select
                  v-model="$v.form.Jellege.$model"
                  :validator="$v.form.Jellege"
                  :options="esemenyJellegek"
                  labelBy="Text"
                ></k-basic-multi-select>
              </b-form-group>
            </div>
            <div class="col-6 pl-2">
              <b-form-group label="Link">
                <k-basic-text-input
                  v-model="$v.form.Link.$model"
                  :validator="$v.form.Link"
                ></k-basic-text-input>
              </b-form-group>
            </div>
          </div>
        </div>
      </b-form>
    </template>
    <template v-slot:footer>
      <div class="footer justify-content-between">
        <k-button
          variant="dark"
          label="Mégsem"
          @click="Close()"
          icon="fas fa-times"
        ></k-button>
        <k-button
          class="ml-2"
          type="submit"
          variant="primary"
          label="Mehet"
          :form="formId"
          icon="fa-paper-plane"
          :loading="formSaving"
        ></k-button>
      </div>
    </template>
  </k-basic-modal-layout>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import required from 'vuelidate/src/validators/required';
import { useModalHelper } from '../../utils/modal';
import { hidrateForm } from '../../utils/common';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import { eventBus } from '../../main';
import { esemenyNaptarService } from '../../services/EsemenyNaptarService';
let defaultForm = {
  Id: 0,
  Nev: '',
  EsemenyTipusa: null,
  Kezdete: null,
  Vege: null,
  Jellege: null,
  Link: '',
};

export default {
  name: 'esemeny-kezelo-modal',
  data() {
    return {
      form: cloneDeep(defaultForm),
      formSaving: false,
      esemenyJellegek: [],
      esemenyTipusok: [],
    };
  },
  setup(props, context) {
    let { formId, IsVueFormValid } = useModalHelper(props, context);
    return { formId, IsVueFormValid };
  },
  mounted() {
    this.LoadForm();
  },
  created() {},
  validations() {
    let validations = {
      form: {
        Nev: { required },
        EsemenyTipusa: { required },
        Kezdete: { required },
        Vege: {},
        Jellege: { required },
        Link: { required },
      },
    };
    return validations;
  },
  methods: {
    Close() {
      this.$emit('close');
    },
    async LoadForm() {
      this.$emit('set-loading', true);
      try {
        this.esemenyJellegek = await esemenyNaptarService.GetEsemenyJellegek();
        this.esemenyTipusok = await esemenyNaptarService.GetEsemenyTipusok();
        if (this.esemenyId != null && this.esemenyId != 0) {
          let result = await esemenyNaptarService.EditEsemeny({
            id: this.esemenyId,
          });
          hidrateForm(this, this.form, result);
        }
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
        this.Close();
      }
      this.$emit('set-loading', false);
    },
    async OnSubmit() {
      if (!this.IsVueFormValid(this)) {
        console.log(this.$v);
        return;
      }
      this.formSaving = true;
      try {
        let data = { ...this.form, Id: this.esemenyId };
        await esemenyNaptarService.SaveEsemeny(data);
        eventBus.$emit('data-update:event');
        NotificationFunctions.SuccessAlert(
          'Eseménynaptár bejegyzés',
          'Esemény adatai mentve'
        );
        this.Close();
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.formSaving = false;
    },
  },

  computed: {
    esemenyId() {
      return this.modal?.data?.id ?? 0;
    },
  },
  watch: {},
  props: {
    modal: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>
